<template>
  <v-container
    id="app-loyalty-questions"
    class="pa-1"
  >
    <screen use-amount />

    <div
      class="pa-3"
      style="height:72vh; display:flex; flex-direction: column;"
    >
      <v-layout style="flex: none">
        <v-flex xs9>
          <div class="headline">
            {{ currentQuestion.title }}
          </div>
        </v-flex>
        <v-flex xs3>
          <div class="headline text-right">
            {{ counter }}
          </div>
        </v-flex>
      </v-layout>

      <v-card
        light
        class="bloc-action-small px-2 py-1 my-3"
        style="flex:1; overflow: auto;"
      >
        <v-radio-group
          v-if="currentQuestion.isRadioType"
          v-model="currentAnswer"
        >
          <v-radio
            v-for="(item, i) in currentQuestion.items"
            :key="i"
            class="pa-2"
            :label="item.label"
            :value="item.value"
          />
        </v-radio-group>

        <v-text-field
          v-else
          ref="answer"
          v-model="currentAnswer"
          class="needsclick"
          :prepend-inner-icon="IconEnum.envelope"
          :type="currentQuestion.type"
          :placeholder="currentQuestion.title"
        />
      </v-card>
    </div>

    <bottom-action
      btn-valid
      btn-cancel
      :btn-valid-disabled="currentAnswer === null || currentAnswer === ''"
      @cancel="cancel"
      @del="del"
      @valid="validAnswer"
    />
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { IconEnum } from '@/modules/Enums'
import { $alert, createReference } from '@/modules/Utils'

export default {
  name: 'LoyaltyQuestionsView',

  props: {
    idBadge: { type: String, default: null },
    clientQuestions: { type: Object, default: null },
    loyaltyQuestions: { type: Object, default: null },
    solde: { type: Number, default: 0 },
    postJackpotAmount: { type: Number, default: null }
  },

  data () {
    return {
      IconEnum,
      //
      clientAnswers: [],
      loyaltyAnswers: [],
      //
      currentQuestion: {},
      currentAnswer: null,
      currentIndex: 0,
      reference: createReference()
    }
  },

  computed: {
    counter () {
      return (
        this.currentQuestion.isClientQuestion
          ? (this.currentIndex + 1)
          : ((this.clientQuestions ? this.clientQuestions.Question.length : 0) + this.currentIndex + 1)
        ) + '/' + (
          (this.clientQuestions ? this.clientQuestions.Question.length : 0)
          + (this.loyaltyQuestions ? this.loyaltyQuestions.Question.length : 0)
        )
    },
    postJackpot () { return this.$store.getters.postJackpot }
  },

  beforeMount () {
    if (this.idBadge === null) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.loyalty_questions'))
    }
  },

  mounted () {
    // Affichage de la première question
    this.clientQuestions
      ? this.formatQuestion(this.clientQuestions.Question[0], true)
      : this.formatQuestion(this.loyaltyQuestions.Question[0], false)
  },

  methods: {
    formatQuestion (question, isClientQuestion) {
      let response = {
        id: question.ID,
        title: question.Titre,
        isClientQuestion: isClientQuestion
      }

      // Détermination du type d'input
      if (question.Reponse === 'L') {
        response.isRadioType = true
      } else {
        response.isRadioType = false
        response.type = question.Reponse === 'N' ? 'number' : 'text'
        // Focus input text
        this.$refs.answer.focus()
      }

      // Si on est sur une liste de réponse
      if (response.isRadioType) {
        response.items = []
        // Formattage des items pour vue (label et valeur)
        for (let [key, value] of Object.entries(question)) {
          if (key[0] === 'A' || key[0] === 'R') {
            let index = parseInt(key.substring(1), 10) - 1
            if (!isNaN(index)) {
              if (response.items[index] === undefined) {
                response.items[index] = { label: null, value: null }
              }

              if (key[0] === 'A') {
                response.items[index].label = value
              } else {
                response.items[index].value = value
              }
            }
          }
        }
      }

      this.currentQuestion = response
    },
    validAnswer () {
      let answer = {
        ID: this.currentQuestion.id,
        Reponse: this.currentAnswer.toString()
      }

      this.currentAnswer = null

      // Si on est sur une question client
      if (this.currentQuestion.isClientQuestion) {
        // Ajout de la réponse au tableau des réponses client
        this.clientAnswers.push(answer)
        // Si il existe une question après
        if (this.clientQuestions.Question[this.currentIndex + 1]) {
          // On affiche la question suivante
          this.currentIndex++
          this.formatQuestion(this.clientQuestions.Question[this.currentIndex], true)
        } else if (this.loyaltyQuestions !== null) {
          // Si on a des question fidélité, on affiche la première
          this.currentIndex = 0
          this.formatQuestion(this.loyaltyQuestions.Question[0], false)
        } else {
          // Sinon il n'y a plus de question, on lance le calcul
          this.startFidCalcul()
        }
      } else {
        // Ajout de la réponse au tableau des réponses fidélité
        this.loyaltyAnswers.push(answer)
        // Si il existe une question après
        if (this.loyaltyQuestions.Question[this.currentIndex + 1]) {
          // On affiche la question suivante
          this.currentIndex++
          this.formatQuestion(this.loyaltyQuestions.Question[this.currentIndex], false)
        } else {
          // Sinon il n'y a plus de question, on lance le calcul
          this.startFidCalcul()
        }
      }
    },
    startFidCalcul () {
      // Appel à la route fidCalcul
      Scan.launchFidCalcul(
        this.idBadge,
        (error) => {
          // En cas d'erreur on retourne à la première question
          $alert(error)
          this.currentIndex = 0
          this.clientAnswers = this.loyaltyAnswers = []
          this.clientQuestions
            ? this.formatQuestion(this.clientQuestions.Question[0], true)
            : this.formatQuestion(this.loyaltyQuestions.Question[0], false)
        },
        this.clientAnswers.length > 0 ? { Question: this.clientAnswers } : null,
        this.loyaltyAnswers.length > 0 ? { Question: this.loyaltyAnswers } : null,
        null,
        this.postJackpotAmount,
        this.solde,
        this.reference
      )
    },
    // *** ACTION BUTTONS ***
    del () {
      // Si on est sur une question client
      if (this.currentQuestion.isClientQuestion) {
        // Si il existe une question client avant
        if (this.clientQuestions.Question[this.currentIndex - 1]) {
          // Suppression de la réponse + affichage question précédente
          this.currentIndex--
          this.clientAnswers.pop()
          this.formatQuestion(this.clientQuestions.Question[this.currentIndex], true)
        } else {
          // Sinon retour home
          this.goBack()
        }
      } else {
        // On est sur une question fidélité
        // Si il existe une question fidélité avant
        if (this.loyaltyQuestions.Question[this.currentIndex - 1]) {
          // Suppression de la réponse + affichage question précédente
          this.currentIndex--
          this.loyaltyAnswers.pop()
          this.formatQuestion(this.loyaltyQuestions.Question[this.currentIndex], false)
        } else {
          // Il n'y a pas de question fidélité avant
          // Si il existe des questions client
          if (this.clientQuestions) {
            // Retour sur la dernière question client
            this.loyaltyAnswers = []
            this.currentIndex = this.clientQuestions.Question.length - 1
            this.formatQuestion(this.clientQuestions.Question[this.currentIndex], true)
          } else {
            // Sinon retour home
            this.goBack()
          }
        }
      }
    },
    goBack () {
      if (this.postJackpot) {
        this.$router.replace({
          name: 'loyalty-jackpot',
          params: {
            idBadge: this.idBadge,
            clientQuestions: this.clientQuestions,
            loyaltyQuestions: this.loyaltyQuestions,
            solde: this.solde,
            postJackpotAmount: this.total
          }
        })
      } else {
        this.$router.replace({ name: 'home', params: { reset: false } })
      }
    },
    cancel () {
      this.$router.replace('/home')
    }
  }
}
</script>
